import { render, staticRenderFns } from "./FlipkartReportEvent.vue?vue&type=template&id=5521bd38&lang=pug"
import script from "./FlipkartReportEvent.vue?vue&type=script&lang=js"
export * from "./FlipkartReportEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports